import React from 'react';

// components
import { Flex, Div } from '../../components/box';
import Avatar from '../../components/avatar';
import Text from '../../components/text';
import EllipsisWithTooltip from '../../components/ellipsis-with-tooltip';
import type { AvatarProps } from '../../components/avatar/avatar';
import { sizes } from './style';

interface PersonDisplayProps {
  profileImage?: string;
  name?: string;
  id?: number | string;
  subtitle?: string | React.ReactNode;
  markup?: React.ReactNode;
  businessUnit?: React.ReactNode;
  size?: keyof typeof sizes;
  avatarVariant?: AvatarProps['variant'];
}

export const PersonDisplay = ({
  profileImage,
  name,
  id,
  subtitle,
  markup,
  size = 'sm',
  avatarVariant,
}: PersonDisplayProps) => {
  const {
    avatar: avatarSize,
    title: { size: titleSize, weight: titleWeight },
    textMarginLeft,
  } = sizes[size];

  return (
    <Flex alignItems={'center'} justifyContent={'flex-start'} flexShrink={1} minWidth={0}>
      <Avatar markup={markup} photo={profileImage} name={name} userId={id} size={avatarSize} variant={avatarVariant} />
      <Flex marginLeft={textMarginLeft} flexDirection={'column'} justifyContent={'center'} minWidth={0}>
        {name && (
          <EllipsisWithTooltip tooltipProps={{ block: true }}>
            <Text weight={titleWeight} size={titleSize}>
              {name}
            </Text>
          </EllipsisWithTooltip>
        )}

        {sizes[size].subtitle && subtitle && (
          <EllipsisWithTooltip tooltipProps={{ block: true }}>
            <Text
              weight={sizes[size].subtitle?.weight}
              marginBottom={'none'}
              size={sizes[size].subtitle?.size}
              variant={'gray600'}
            >
              {subtitle}
            </Text>
          </EllipsisWithTooltip>
        )}
      </Flex>
    </Flex>
  );
};

export const VerticalPersonDisplay = ({
  profileImage,
  name,
  id,
  subtitle,
  markup,
  businessUnit = null,
  size = 'sm',
}: PersonDisplayProps) => {
  const {
    avatar: avatarSize,
    title: { size: titleSize, weight: titleWeight },
  } = sizes[size];

  return (
    <Flex alignItems={'center'} flexDirection={'column'} gap={'sm'}>
      <Avatar markup={markup} photo={profileImage} name={name} userId={id} size={avatarSize} />
      <Div>
        {businessUnit}
        {name && (
          <Text align={'center'} weight={titleWeight} marginBottom={'none'} size={titleSize}>
            {name}
          </Text>
        )}
        {sizes[size].subtitle && subtitle && (
          <Text
            weight={sizes[size].subtitle?.weight}
            marginBottom={'none'}
            size={sizes[size].subtitle?.size}
            variant={'gray600'}
            align={'center'}
          >
            {subtitle}
          </Text>
        )}
      </Div>
    </Flex>
  );
};

export default PersonDisplay;
